export default __webpack_public_path__ + "static/media/user_image_placeholder.78ee57b7.svg";